import ContributorsSlider from './ContributorsSlider';

export default ContributorsSlider;
